import React, { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { getSubstores } from "../API  Functions/ProfileFunctions";
import LoadingSpinner from "../components/Loading";
import i18next from "i18next";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    width: "50%",
    padding: "30px",
    borderRadius: "18px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "10px",
  },
  cancelIcon: {
    cursor: "pointer",
  },
};

const ExportInventoryModal = ({
  isOpen,
  onClose,
  onExport,
  exportFields,
  masterStore,
  is_master_Store,
}) => {
  const { t } = useTranslation();
  const [fields, setFields] = useState([]);
  const [stores, setStores] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [step, setStep] = useState(1); // Step 1 = stores, Step 2 = fields
  const [loading, setLoading] = useState(false);


  console.log("masterStore---->", masterStore);


  useEffect(() => {
    if (isOpen) {
      setFields(["barcode", "product_name", "sale_price"]);
      setStep(is_master_Store ? 1 : 2); // Skip store selection if no master store
      if (is_master_Store) fetchSubStores();
    }
  }, [isOpen]);

  const fetchSubStores = async () => {
    setLoading(true);
    if (!masterStore) {
      setLoading(false);
      return;
    }
    try {
      const res = await getSubstores(masterStore.store_id);
      const substoresList = res?.response || [];
      const fullList = [
        masterStore,
        ...substoresList.filter((s) => s.store_id !== masterStore.store_id),
      ];
      setStores(fullList);
      setLoading(false);

    } catch (err) {
      console.error("Error fetching substores:", err);
    }
  };

  const handleStoreChange = (storeId) => {
    if (storeId === "all") {
      setSelectedStores((prev) =>
        prev.length === stores.length ? [] : stores.map((s) => s.store_id)
      );
    } else {
      setSelectedStores((prev) =>
        prev.includes(storeId)
          ? prev.filter((id) => id !== storeId)
          : [...prev, storeId]
      );
    }
  };

  const handleCheckboxChange = (field) => {
    setFields((prev) =>
      prev.includes(field)
        ? prev.filter((f) => f !== field)
        : [...prev, field]
    );
  };

  const handleNext = () => setStep(2);
  const handleBack = () => setStep(1);

  return (

    isOpen && (

      <>
        {loading && <LoadingSpinner />}
        <div style={styles.overlay} onClick={onClose}></div>
        <div style={styles.container}>
          <div style={styles.header}>
            <p style={styles.title}>{t("Export Inventory")}</p>
            <CloseOutlined style={styles.cancelIcon} onClick={onClose} />
          </div>

          {/* Step 1: Store Selection */}
          {step === 1 && is_master_Store && (
            <>
              <h2 className="text-base mb-2 italic text-gray-600">
                {t("Select the stores from which to export inventory data")}
              </h2>
              <div className="border border-gray-300 rounded-lg p-4 max-h-64 overflow-y-auto bg-gray-50">
                <label className="block mb-2">
                  <input
                    type="checkbox"
                    checked={selectedStores.length === stores.length}
                    onChange={() => handleStoreChange("all")}
                    className="me-2"
                  />
                  {t("All Stores")}
                </label>
                {stores.map((store) => (
                  <label key={store.store_id} className="block mb-2">
                    <input
                      type="checkbox"
                      value={store.store_id}
                      checked={selectedStores.includes(store.store_id)}
                      onChange={() => handleStoreChange(store.store_id)}
                      className="me-2"
                    />
                    {i18next.language === "ar" ? store.store_name_ar : store.store_name}
                    {/* {store.store_name} */}
                  </label>
                ))}
              </div>

              {/* Buttons */}
              <div className="grid grid-cols-3 gap-4 pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  className="w-full px-2 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  {t("Cancel")}
                </button>
                <button
                  disabled={selectedStores.length === 0}
                  onClick={handleNext}
                  className={`w-full px-2 py-2 rounded-lg font-semibold text-white ${selectedStores.length === 0
                    ? "bg-primaryBlue opacity-50 cursor-not-allowed"
                    : "bg-primaryBlue hover:bg-gray-600"
                    }`}
                >
                  {t("Next")}
                </button>
              </div>
            </>
          )}

          {/* Step 2: Field Selection */}
          {step === 2 && (
            <>
              <h2 className="text-base mb-2 italic text-gray-600">
                {t("Select Fields to Export")}
              </h2>
              <div className="border border-gray-300 rounded-lg p-4 max-h-64 overflow-y-auto bg-gray-50">
                {exportFields.map((field) => (
                  <label key={field.key} className="block mb-2">
                    <input
                      type="checkbox"
                      value={field.key}
                      checked={fields.includes(field.key)}
                      onChange={() => handleCheckboxChange(field.key)}
                      className="me-2"
                    />
                    {field.label}
                  </label>
                ))}
              </div>

              {/* Buttons */}
              <div className="grid grid-cols-3 gap-4 pt-4">
                {is_master_Store && (
                  <button
                    onClick={handleBack}
                    className="w-full px-2 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
                  >
                    {t("Back")}
                  </button>
                )}
                <button
                  disabled={fields.length === 0}
                  onClick={() => onExport(fields, selectedStores)}
                  className={`w-full px-2 py-2 rounded-lg font-semibold text-white ${fields.length === 0
                    ? "bg-primaryBlue opacity-50 cursor-not-allowed"
                    : "bg-primaryBlue hover:bg-gray-600"
                    }`}
                >
                  {t("Export")}
                </button>
              </div>
            </>
          )}
        </div>
      </>
    )
  );
};

export default ExportInventoryModal;



// import React, { useEffect, useState } from "react";
// import { CloseOutlined } from "@ant-design/icons";
// import { useTranslation } from "react-i18next";

// const styles = {
//   overlay: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     zIndex: 999,
//   },
//   container: {
//     width: "50%",
//     padding: "30px",
//     borderRadius: "18px",
//     margin: "0 auto",
//     backgroundColor: "#ffffff",
//     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     position: "fixed",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     zIndex: 1000,
//   },
//   header: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   title: {
//     fontSize: "20px",
//     fontWeight: "bold",
//     textAlign: "left",
//     marginBottom: "10px",
//   },
//   cancelIcon: {
//     cursor: "pointer",
//   },
//   description: {
//     textAlign: "left",
//     fontSize: "16px",
//     color: "#272728",
//     marginTop: "10px",
//   },
//   input: {
//     width: "100%",
//     padding: "10px",
//     borderRadius: "12px",
//     border: "1px solid #CCCCCC",
//     marginBottom: "20px",
//     boxSizing: "border-box",
//   },
//   buttonContainer: {
//     display: "flex",
//     justifyContent: "center",
//   },
//   button: {
//     width: "180px",
//     height: "45px",
//     borderRadius: "5px",
//     border: "none",
//     cursor: "pointer",
//     marginRight: "10px",
//     transition: "opacity 0.3s", // Smooth transition for opacity change
//   },
//   confirmButton: {
//     backgroundColor: "primaryBlue",
//     color: "#FFFFFF",
//   },
//   cancelButton: {
//     backgroundColor: "#CCCCCC",
//     color: "#000000",
//   },
// };
// const ExportInventoryModal = ({ isOpen, onClose, onExport, exportFields }) => {
//   const [fields, setFields] = useState([]);
//   const { t, i18n } = useTranslation();

//   useEffect(() => {
//     if (isOpen) {
//       setFields(["barcode", "product_name", "sale_price"]);
//     }
//   }, [isOpen]);

//   const handleCheckboxChange = (field) => {
//     setFields((prev) =>
//       prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field]
//     );
//   };

//   return (
//     isOpen && (
//       <>
//         <div
//           className="backdrop-blur"
//           style={styles.overlay}
//           onClick={onClose}
//         ></div>
//         <div style={styles.container}>
//           <div style={styles.header}>
//             <p style={styles.title}>{t("Export Inventory")}</p>
//             <CloseOutlined style={styles.cancelIcon} onClick={onClose} />
//           </div>

//           <h2 className="text-base mb-2 italic text-gray-600 ">{t("Select Fields to Export")}</h2>
//           <div className="border border-gray-300 rounded-lg p-4 max-h-64 overflow-y-auto bg-gray-50">
//             {exportFields.map((field) => (
//               <label key={field.key} className="block mb-2">
//                 <input
//                   type="checkbox"
//                   value={field.key}
//                   checked={fields.includes(field.key)}
//                   onChange={() => handleCheckboxChange(field.key)}
//                   className="me-2"
//                 />
//                 {field.label}
//               </label>
//             ))}
//           </div>
//           {/* Action Buttons */}
//           <div className="grid grid-cols-3 gap-4 pt-4">
//             <button
//               type="button"
//               onClick={onClose}
//               className="w-full px-2 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
//             >
//               {t("Cancel")}
//             </button>
//             <button
//               // disabled={!base64File || loading}
//               onClick={() => onExport(fields)}
//               className={`w-full px-2 py-2 rounded-lg font-semibold text-white ${
//                 fields?.length === 0
//                   ? "bg-primaryBlue opacity-50 cursor-not-allowed"
//                   : "bg-primaryBlue hover:bg-gray-600"
//               }`}
//               // className="w-full px-4 py-2 bg-primaryBlue text-white rounded-lg hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {t("Export")}
//             </button>
//           </div>
//         </div>
//       </>
//     )
//   );
// };

// export default ExportInventoryModal;
